import { gql } from '__generated__';

export const OrderFieldsFragment = gql(`
  fragment OrderFields on Order {
    id
    event {
      id
      title
      start_date
      end_date
      payment_methods
      e_invoicing_enabled
      require_company_for_bank_transfer
      brand_color
    }
    invoice_id
    invoice_amount
    paid_passed_on_fee
    remaining_passed_on_fee
    credited_amount
    remaining_amount
    invoice_url
    fee_invoice_url
    dashboard_url
    draft
    start_bank_transfer_payment
    invoice_date
    due_date
    company_name
    is_charity
    reference
    token
    street
    house_number
    zip_code
    city
    extra_address_line
    country
    phone
    vat_id
    vat_id_editable
    e_invoicing_recipient {
      address
      country
      name
    }
    allow_companies
    editable
    participant {
      id
      email
      full_name
    }
    participant_fields {
      ...ParticipantFieldFields
    }
    participant_field_entries {
      ...ParticipantFieldEntryFields
    }
    stand_alone_upgrades {
      ...UpgradeFields
    }
    summary(include_inactive: true) {
      id
      tickets {
        quantity
        purchase {
          id
          amount
          coupon_code {
            id
            value
            coupon {
              id
              type
              value
            }
          }
          promotion {
            id
            title
          }
          ticket {
            id
            title
          }
          time_slot {
            id
            start_date
            start_time
            multi_date
            title
          }
        }
      }
      products {
        quantity
        purchase {
          id
          amount
          coupon_code {
            id
            value
            coupon {
              id
              type
              value
            }
          }
          promotion {
            id
            title
          }
          product {
            id
            title
            type
          }
          product_variant {
            id
            title
          }
        }
      }
    }
    pending_bank_transfer_payment {
      id
      amount
      bank_name
      bank_iban
      transfer_reference
      status_url
    }
  }
`);

export default gql(`
  query GetOrderForDashboard($order_id: ID!, $token: String) {
    order(id: $order_id, token: $token) {
      ...OrderFields
    }
  }
`);
